import {
  AUTH_HEADER,
  SESSION_STORAGE_AUTH_FLAG,
  SESSION_STORAGE_TOKEN,
} from "../../keys";
import { ERRORS } from "../constants/errors";
import { loginService } from "../services/authService";
import { resetGlobalHeader, setGlobalHeader } from "../utils/apiUtils";
import { encrypt } from "../utils/cryptoUtils";
import { errorHandler } from "../utils/helpers";
import { setSessionStorage } from "../utils/storageUtils";

const loginManager = async (
  userName: string,
  password: string
): Promise<string> => {
  const response = await errorHandler(loginService)(userName, password);
  const loginToken: string | undefined = response?.data?.respData;
  if (loginToken) {
    const encryptedToken = encrypt(loginToken);
    setGlobalHeader(AUTH_HEADER, loginToken);
    setSessionStorage(SESSION_STORAGE_TOKEN, encryptedToken);
    setSessionStorage(SESSION_STORAGE_AUTH_FLAG, "true");
    return loginToken;
  } else {
    throw new Error(
      ERRORS.SOMETHING_WENT_WRONG + " " + ERRORS.PLEASE_CONTACT_ADMIN
    );
  }
};

const logoutManager = async () => {
  // const response = await errorHandler(logoutService)(userName); //handle when logout API is live
  //Authentication Failed, Please Login Again!
  resetGlobalHeader(AUTH_HEADER);
  setSessionStorage(SESSION_STORAGE_TOKEN, "");
  setSessionStorage(SESSION_STORAGE_AUTH_FLAG, "false");
  return;
};

export { loginManager, logoutManager };
